module.exports = {
	"contract_name": "TokenRegistry",
	"abi": [
		{
			"constant": false,
			"inputs": [
				{
					"name": "_token",
					"type": "address"
				},
				{
					"name": "_index",
					"type": "uint256"
				}
			],
			"name": "removeToken",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_name",
					"type": "string"
				}
			],
			"name": "getTokenAddressByName",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_symbol",
					"type": "string"
				}
			],
			"name": "getTokenAddressBySymbol",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_token",
					"type": "address"
				},
				{
					"name": "_swarmHash",
					"type": "bytes"
				}
			],
			"name": "setTokenSwarmHash",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_token",
					"type": "address"
				}
			],
			"name": "getTokenMetaData",
			"outputs": [
				{
					"name": "",
					"type": "address"
				},
				{
					"name": "",
					"type": "string"
				},
				{
					"name": "",
					"type": "string"
				},
				{
					"name": "",
					"type": "uint8"
				},
				{
					"name": "",
					"type": "bytes"
				},
				{
					"name": "",
					"type": "bytes"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_token",
					"type": "address"
				},
				{
					"name": "_name",
					"type": "string"
				},
				{
					"name": "_symbol",
					"type": "string"
				},
				{
					"name": "_decimals",
					"type": "uint8"
				},
				{
					"name": "_ipfsHash",
					"type": "bytes"
				},
				{
					"name": "_swarmHash",
					"type": "bytes"
				}
			],
			"name": "addToken",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_token",
					"type": "address"
				},
				{
					"name": "_name",
					"type": "string"
				}
			],
			"name": "setTokenName",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"name": "tokens",
			"outputs": [
				{
					"name": "token",
					"type": "address"
				},
				{
					"name": "name",
					"type": "string"
				},
				{
					"name": "symbol",
					"type": "string"
				},
				{
					"name": "decimals",
					"type": "uint8"
				},
				{
					"name": "ipfsHash",
					"type": "bytes"
				},
				{
					"name": "swarmHash",
					"type": "bytes"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"name": "tokenAddresses",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_name",
					"type": "string"
				}
			],
			"name": "getTokenByName",
			"outputs": [
				{
					"name": "",
					"type": "address"
				},
				{
					"name": "",
					"type": "string"
				},
				{
					"name": "",
					"type": "string"
				},
				{
					"name": "",
					"type": "uint8"
				},
				{
					"name": "",
					"type": "bytes"
				},
				{
					"name": "",
					"type": "bytes"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "getTokenAddresses",
			"outputs": [
				{
					"name": "",
					"type": "address[]"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_token",
					"type": "address"
				},
				{
					"name": "_ipfsHash",
					"type": "bytes"
				}
			],
			"name": "setTokenIpfsHash",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_symbol",
					"type": "string"
				}
			],
			"name": "getTokenBySymbol",
			"outputs": [
				{
					"name": "",
					"type": "address"
				},
				{
					"name": "",
					"type": "string"
				},
				{
					"name": "",
					"type": "string"
				},
				{
					"name": "",
					"type": "uint8"
				},
				{
					"name": "",
					"type": "bytes"
				},
				{
					"name": "",
					"type": "bytes"
				}
			],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_token",
					"type": "address"
				},
				{
					"name": "_symbol",
					"type": "string"
				}
			],
			"name": "setTokenSymbol",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"payable": false,
			"type": "function"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "token",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "name",
					"type": "string"
				},
				{
					"indexed": false,
					"name": "symbol",
					"type": "string"
				},
				{
					"indexed": false,
					"name": "decimals",
					"type": "uint8"
				},
				{
					"indexed": false,
					"name": "ipfsHash",
					"type": "bytes"
				},
				{
					"indexed": false,
					"name": "swarmHash",
					"type": "bytes"
				}
			],
			"name": "LogAddToken",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "token",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "name",
					"type": "string"
				},
				{
					"indexed": false,
					"name": "symbol",
					"type": "string"
				},
				{
					"indexed": false,
					"name": "decimals",
					"type": "uint8"
				},
				{
					"indexed": false,
					"name": "ipfsHash",
					"type": "bytes"
				},
				{
					"indexed": false,
					"name": "swarmHash",
					"type": "bytes"
				}
			],
			"name": "LogRemoveToken",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "token",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "oldName",
					"type": "string"
				},
				{
					"indexed": false,
					"name": "newName",
					"type": "string"
				}
			],
			"name": "LogTokenNameChange",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "token",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "oldSymbol",
					"type": "string"
				},
				{
					"indexed": false,
					"name": "newSymbol",
					"type": "string"
				}
			],
			"name": "LogTokenSymbolChange",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "token",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "oldIpfsHash",
					"type": "bytes"
				},
				{
					"indexed": false,
					"name": "newIpfsHash",
					"type": "bytes"
				}
			],
			"name": "LogTokenIpfsHashChange",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "token",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "oldSwarmHash",
					"type": "bytes"
				},
				{
					"indexed": false,
					"name": "newSwarmHash",
					"type": "bytes"
				}
			],
			"name": "LogTokenSwarmHashChange",
			"type": "event"
		}
	],
	"unlinked_binary": "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",
	"networks": {
		"1": {
			"links": {},
			"events": {
				"0xd8d928b0b50ca11d9dc273236b46f3526515b03602f71f3a6af4f45bd9fa9144": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "name",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "symbol",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "decimals",
							"type": "uint8"
						},
						{
							"indexed": false,
							"name": "ipfsHash",
							"type": "bytes"
						},
						{
							"indexed": false,
							"name": "swarmHash",
							"type": "bytes"
						}
					],
					"name": "LogAddToken",
					"type": "event"
				},
				"0x32c54f1e2ea75844ded7517e7dbcd3895da7cd0c28f9ab9f9cf6ecf5f83762c6": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "name",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "symbol",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "decimals",
							"type": "uint8"
						},
						{
							"indexed": false,
							"name": "ipfsHash",
							"type": "bytes"
						},
						{
							"indexed": false,
							"name": "swarmHash",
							"type": "bytes"
						}
					],
					"name": "LogRemoveToken",
					"type": "event"
				},
				"0x4a6dbfc867b179991dec22ff19960f0a94d8d9d891fc556f547764670340e8ae": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "oldName",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "newName",
							"type": "string"
						}
					],
					"name": "LogTokenNameChange",
					"type": "event"
				},
				"0x53d878a6530e56c9bc96548fa0a8cae4f1d1f49c86b0e934c086b992ebb6998f": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "oldSymbol",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "newSymbol",
							"type": "string"
						}
					],
					"name": "LogTokenSymbolChange",
					"type": "event"
				},
				"0x5b19f79ac4e8cfa820815502e11615f1a449e28155dc289ec5cac1a11f908694": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "oldIpfsHash",
							"type": "bytes"
						},
						{
							"indexed": false,
							"name": "newIpfsHash",
							"type": "bytes"
						}
					],
					"name": "LogTokenIpfsHashChange",
					"type": "event"
				},
				"0xc3168fdc13112e44a031057dbf6c609b33353addb4d8037d24543e22cbfe2acd": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "oldSwarmHash",
							"type": "bytes"
						},
						{
							"indexed": false,
							"name": "newSwarmHash",
							"type": "bytes"
						}
					],
					"name": "LogTokenSwarmHashChange",
					"type": "event"
				}
			},
			"updated_at": 1502488442000,
			"address": "0x926a74c5c36adf004c87399e65f75628b0f98d2c"
		},
		"42": {
			"links": {},
			"events": {
				"0xd8d928b0b50ca11d9dc273236b46f3526515b03602f71f3a6af4f45bd9fa9144": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "name",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "symbol",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "decimals",
							"type": "uint8"
						},
						{
							"indexed": false,
							"name": "ipfsHash",
							"type": "bytes"
						},
						{
							"indexed": false,
							"name": "swarmHash",
							"type": "bytes"
						}
					],
					"name": "LogAddToken",
					"type": "event"
				},
				"0x32c54f1e2ea75844ded7517e7dbcd3895da7cd0c28f9ab9f9cf6ecf5f83762c6": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "name",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "symbol",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "decimals",
							"type": "uint8"
						},
						{
							"indexed": false,
							"name": "ipfsHash",
							"type": "bytes"
						},
						{
							"indexed": false,
							"name": "swarmHash",
							"type": "bytes"
						}
					],
					"name": "LogRemoveToken",
					"type": "event"
				},
				"0x4a6dbfc867b179991dec22ff19960f0a94d8d9d891fc556f547764670340e8ae": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "oldName",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "newName",
							"type": "string"
						}
					],
					"name": "LogTokenNameChange",
					"type": "event"
				},
				"0x53d878a6530e56c9bc96548fa0a8cae4f1d1f49c86b0e934c086b992ebb6998f": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "oldSymbol",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "newSymbol",
							"type": "string"
						}
					],
					"name": "LogTokenSymbolChange",
					"type": "event"
				},
				"0x5b19f79ac4e8cfa820815502e11615f1a449e28155dc289ec5cac1a11f908694": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "oldIpfsHash",
							"type": "bytes"
						},
						{
							"indexed": false,
							"name": "newIpfsHash",
							"type": "bytes"
						}
					],
					"name": "LogTokenIpfsHashChange",
					"type": "event"
				},
				"0xc3168fdc13112e44a031057dbf6c609b33353addb4d8037d24543e22cbfe2acd": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "oldSwarmHash",
							"type": "bytes"
						},
						{
							"indexed": false,
							"name": "newSwarmHash",
							"type": "bytes"
						}
					],
					"name": "LogTokenSwarmHashChange",
					"type": "event"
				}
			},
			"updated_at": 1502391794385,
			"address": "0xf18e504561f4347bea557f3d4558f559dddbae7f"
		},
		"50": {
			"links": {},
			"events": {
				"0xd8d928b0b50ca11d9dc273236b46f3526515b03602f71f3a6af4f45bd9fa9144": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "name",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "symbol",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "decimals",
							"type": "uint8"
						},
						{
							"indexed": false,
							"name": "ipfsHash",
							"type": "bytes"
						},
						{
							"indexed": false,
							"name": "swarmHash",
							"type": "bytes"
						}
					],
					"name": "LogAddToken",
					"type": "event"
				},
				"0x32c54f1e2ea75844ded7517e7dbcd3895da7cd0c28f9ab9f9cf6ecf5f83762c6": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "name",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "symbol",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "decimals",
							"type": "uint8"
						},
						{
							"indexed": false,
							"name": "ipfsHash",
							"type": "bytes"
						},
						{
							"indexed": false,
							"name": "swarmHash",
							"type": "bytes"
						}
					],
					"name": "LogRemoveToken",
					"type": "event"
				},
				"0x4a6dbfc867b179991dec22ff19960f0a94d8d9d891fc556f547764670340e8ae": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "oldName",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "newName",
							"type": "string"
						}
					],
					"name": "LogTokenNameChange",
					"type": "event"
				},
				"0x53d878a6530e56c9bc96548fa0a8cae4f1d1f49c86b0e934c086b992ebb6998f": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "oldSymbol",
							"type": "string"
						},
						{
							"indexed": false,
							"name": "newSymbol",
							"type": "string"
						}
					],
					"name": "LogTokenSymbolChange",
					"type": "event"
				},
				"0x5b19f79ac4e8cfa820815502e11615f1a449e28155dc289ec5cac1a11f908694": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "oldIpfsHash",
							"type": "bytes"
						},
						{
							"indexed": false,
							"name": "newIpfsHash",
							"type": "bytes"
						}
					],
					"name": "LogTokenIpfsHashChange",
					"type": "event"
				},
				"0xc3168fdc13112e44a031057dbf6c609b33353addb4d8037d24543e22cbfe2acd": {
					"anonymous": false,
					"inputs": [
						{
							"indexed": true,
							"name": "token",
							"type": "address"
						},
						{
							"indexed": false,
							"name": "oldSwarmHash",
							"type": "bytes"
						},
						{
							"indexed": false,
							"name": "newSwarmHash",
							"type": "bytes"
						}
					],
					"name": "LogTokenSwarmHashChange",
					"type": "event"
				}
			},
			"updated_at": 1503318938228,
			"address": "0x0b1ba0af832d7c05fd64161e0db78e85978e8082"
		}
	},
	"schema_version": "0.0.5",
	"updated_at": 1503318938228
};


//////////////////
// WEBPACK FOOTER
// ./~/0x.js/lib/src/artifacts/TokenRegistry.json
// module id = 370
// module chunks = 2